let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("if5dj")).then(() => parcelRequire('4IPux'));